import { render } from "./ProjectStretchGoalsList.vue?vue&type=template&id=5d3bd871"
import script from "./ProjectStretchGoalsList.vue?vue&type=script&lang=js"
export * from "./ProjectStretchGoalsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__